import React from 'react';
import Row from '../Row';
import Col from '../Col';
import Icon from '../Icon';

const UserChatHeader = ({
  title,
  referenceType,
  description,
  profileIcon,
  address,
  from,
  onClickBack,
  backIcon,
  extraInfo,
  onNavigate
}) => {

  /*
    Modified By: Sai Prasad
    Modified Date: 02/09/2022
    Jira Ticket: JUN-3090
    Description: display additional details in message preview 
  */
    const displayExtraInfo = () => {
      return (
        <div style={{marginLeft:30, marginRight: 10, marginBottom: 5}}>
        <Row>
          {extraInfo.propertyName && 
          <Col md={4} xs={12}>
            <div className='extraData_heading'>Property:  </div>
           <div className='extraData'>{` ${extraInfo.propertyName}`}</div>
          </Col>}
          {extraInfo.itemName && 
          <Col md={4} xs={12}>
          <div className='extraData_heading'>Item: </div>
          <div className='extraData'>{extraInfo.itemName}</div>
          </Col>}
          {extraInfo.issueType &&
          <Col md={4} xs={12}>
          <div className='extraData_heading'>Issue Type: </div>
          <div className='extraData'>{extraInfo.issueType}</div>
          </Col>}
        </Row>
        </div>
      )
    }
    return (
      <>
        <Row>
          {backIcon !== false && 
          <Col md={1} xs={2} 
          id={backIcon}
          >
          <div style={{cursor: 'pointer', paddingTop:"20px", marginLeft:"10px"}} onClick={onClickBack}>
            <Icon
                glyph={'arrow-left'}
                weight="solid"
                size="medium"
            />
            </div>
          </Col>
          }
        <Col md={6} xs={10}>
          <div className='areaUsers'>
            {from ?
            <div className='areaUsersIcon'> <img src={profileIcon ? profileIcon : '/assets/avatar.svg'} alt='' /> </div>
            :
            /* 
                  Modified By: Sai Prasad
                  Modified Date: 23/08/2022 1:15 PM
                  Jira Ticket: JUN-3149
                  Description: updated the inbox profile icons 
               */
            <div className='userIcon'> 
                <Icon
                    glyph={profileIcon}
                    weight="light"
                    size="custom"
                />
            </div>}
            <div className='areaUsersInfo'>
              <div className='areaUsersInfo__UserName' style={{cursor: onNavigate && 'pointer'}} onClick={onNavigate}>{title}
              </div>
              {description &&
                 <div className='areaUsersInfo__UserDescription'>{description}</div>
              }
            </div>
          </div>
        </Col>
        {address && 
        <Col md={6} xs={12}>
          <div className='areaAddress'> <Icon
            glyph="map-marker"
            weight="light"
            size="medium"
          />{address}</div>
        </Col>}
      </Row> 
      
      {referenceType === "Ticket" && displayExtraInfo()}

              <hr className='lineHeadding' />
              </>
    )
}
export default UserChatHeader;